import { atom } from 'jotai';

export const likeLookupAtom = atom<Record<string, boolean>>({});
